import React from 'react';
import type { IconProps } from '../types';

export const NavigationPanelReveal = (props: IconProps) => (
  <svg
    width="23px"
    height="23px"
    viewBox="0 0 1008 1296"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <g transform="translate(81 191)">
      {/* Arrow */}
      <path
        d="M821.676 412.344C821.676 420.098 818.605 427.559 813.117 433.043C807.633 438.528 800.172 441.602 792.422 441.602H301.602L452.164 592.164C457.758 597.649 460.941 605.109 461.012 612.934C461.051 620.762 457.941 628.258 452.418 633.816C446.898 639.34 439.363 642.41 431.539 642.375C423.746 642.34 416.25 639.156 410.801 633.523L210.285 433.008C210.027 432.75 209.957 432.387 209.699 432.094L209.664 432.129C207.25 429.641 205.313 426.715 203.922 423.535L203.883 423.426C203.773 423.168 203.773 422.914 203.703 422.621V422.656C202.641 419.695 202.02 416.586 201.91 413.441C201.91 412.453 201.984 411.43 202.094 410.441C202.238 407.992 202.715 405.578 203.48 403.238C203.773 402.25 204.105 401.301 204.508 400.348C205.895 397.133 207.836 394.168 210.285 391.645L410.801 191.164C422.285 180.086 440.496 180.266 451.762 191.531C463.023 202.832 463.207 221.043 452.164 232.527L301.602 383.09H792.422C808.586 383.09 821.676 396.18 821.676 412.344Z"
        fill="currentColor"
      />

      {/* Circular path */}
      <path
        d="M412.082 2.754C489.762 2.934 565.754 25.098 631.363 66.68C696.934 108.297 749.41 167.609 782.656 237.789C789.531 252.418 783.277 269.824 768.648 276.738C754.02 283.613 736.574 277.324 729.699 262.695C683.988 165.777 596.543 95.055 492.211 70.66C387.871 46.266 278.129 70.84 194.16 137.398C110.23 203.996 61.266 305.262 61.266 412.41C61.266 519.563 110.234 620.832 194.16 687.426C278.125 753.984 387.871 778.594 492.211 754.164C596.551 729.773 683.984 659.047 729.699 562.129C732.953 555.035 738.914 549.512 746.266 546.844C753.617 544.176 761.734 544.539 768.793 547.867C775.852 551.195 781.301 557.23 783.898 564.617C786.492 571.969 786.02 580.086 782.617 587.109C740.707 675.977 668.258 746.816 578.477 786.707C488.695 826.605 387.535 832.934 293.512 804.48C199.453 776.027 118.777 714.738 66.152 631.758C13.527 548.781 -7.5 449.637 6.871 352.43C21.246 255.262 70.066 166.473 144.449 102.246C218.832 38.066 313.809 2.738 412.074 2.738Z"
        fill="currentColor"
        opacity="0.65"
      />
    </g>
  </svg>
);

export default NavigationPanelReveal;
